import { computed, reactive, useI18n } from '#imports';

export const useExpertsModel = () => {
  const { t } = useI18n({ useScope: 'local' });
  const loadedPhotos = reactive<Record<string, boolean>>({});
  const title = computed(() => t('a_side_title_experts'));

  const getPhotoSrc = (photo: unknown): string =>
    typeof photo === 'string' ? photo.trim() : '';

  const isImageLoaded = (photo: unknown): boolean =>
    loadedPhotos[getPhotoSrc(photo)] === true;

  // При гидрации load/error уже могли произойти до подключения обработчиков.
  const syncImageState = (image: unknown) => {
    if (!(image instanceof HTMLImageElement)) return;

    const photo = image.getAttribute('src');
    if (photo) {
      loadedPhotos[photo] = image.complete && image.naturalWidth > 0;
    }
  };

  return { title, getPhotoSrc, isImageLoaded, syncImageState };
};
